exports["TR"] = require("./TR.js");
exports["RO"] = require("./RO.js");
exports["DE"] = require("./DE.js");
exports["AZ"] = require("./AZ.js");
exports["DK"] = require("./DK.js");
exports["IS"] = require("./IS.js");